/**
 * Centralised external link helpers for Petals & Promises.
 *
 * Source-of-truth for WhatsApp number + the pre-filled message used on every
 * "Chat on WhatsApp" CTA. Update these constants in ONE place and every CTA
 * across the site picks it up automatically.
 */

import { BRAND } from "@/data/content";

// Pre-filled WhatsApp greeting requested by the user. Keep human-readable.
export const WHATSAPP_DEFAULT_MESSAGE = "Hey, Petals and Promises Team";

/**
 * Build a wa.me link with the standard pre-filled message.
 * @param {string} [message]  optional override; defaults to the brand greeting
 * @returns {string} fully-formed wa.me URL safe for `<a href>` and `window.open`
 */
export function getWhatsAppLink(message = WHATSAPP_DEFAULT_MESSAGE) {
  // BRAND.whatsapp is already digits-only ("917300330068")
  const phone = String(BRAND.whatsapp || "").replace(/\D/g, "");
  return `https://wa.me/${phone}?text=${encodeURIComponent(message)}`;
}
